import React from 'react';

export const ExternalUrlIcon = (props) => {
  return (
    <svg viewBox='0 0 30 30' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/external-url' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='eva:external-link-fill' transform='translate(1.500000, 1.500000)'>
          <rect id='ViewBox' x='0' y='0' width='27' height='27'></rect>
          <g
            id='Group'
            transform='translate(3.375000, 3.375000)'
            fill='currentColor'
            fillRule='nonzero'
          >
            <path
              d='M19.125,9 C18.5036797,9 18,9.50367966 18,10.125 L18,16.875 C18,17.4963203 17.4963203,18 16.875,18 L3.375,18 C2.75367966,18 2.25,17.4963203 2.25,16.875 L2.25,3.375 C2.25,2.75367966 2.75367966,2.25 3.375,2.25 L10.125,2.25 C10.7463203,2.25 11.25,1.74632034 11.25,1.125 C11.25,0.503679656 10.7463203,0 10.125,0 L3.375,0 C1.51103897,0 0,1.51103897 0,3.375 L0,16.875 C0,18.738961 1.51103897,20.25 3.375,20.25 L16.875,20.25 C18.738961,20.25 20.25,18.738961 20.25,16.875 L20.25,10.125 C20.25,9.50367966 19.7463203,9 19.125,9 Z'
              id='Path'
            ></path>
            <path
              d='M14.625,2.25 L16.4025,2.25 L9.32625,9.315 C9.11327327,9.52623742 8.99347689,9.81378277 8.99347689,10.11375 C8.99347689,10.4137172 9.11327327,10.7012626 9.32625,10.9125 C9.53748742,11.1254767 9.82503277,11.2452731 10.125,11.2452731 C10.4249672,11.2452731 10.7125126,11.1254767 10.92375,10.9125 L18,3.8475 L18,5.625 C18,6.24632034 18.5036797,6.75 19.125,6.75 C19.7463203,6.75 20.25,6.24632034 20.25,5.625 L20.25,1.125 C20.25,0.503679656 19.7463203,0 19.125,0 L14.625,0 C14.0036797,0 13.5,0.503679656 13.5,1.125 C13.5,1.74632034 14.0036797,2.25 14.625,2.25 Z'
              id='Path'
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
